export const paymentTerms = [
    { id: 30, name: "30 dagar netto" },
    { id: 2, name: "2 postförskott" },
    { id: 6, name: "Förskott" },
    { id: 7, name: "Postförskott KK" },
    { id: 8, name: "Förskott swish" }
]